"use strict";

angular.module("core")
.component("listingFilter", {
    templateUrl: require("./listing-filter.component.html"),
    controllerAs: "listingFilterCtrl",
    bindings: {
        modalTitle: "<",
        statusService: "<?",
        tagService: "<?",
        component: "@?"
    },
    controller: function(
        $scope, $state, $filter, StateExtensionService, ModalService
    ) {
        $scope.filters = {};
        $scope.filterCount = 0;

        var component = "default";
        if (this.component) {
            component = this.component;
        }

        var componentFiltersEmitter = {
            "default": ["dateFilterUpdated", "statusFilterUpdated"],
            "goods-transfer": ["inventoryQuantityFilterUpdated"],
            "invoice": ["dateFilterUpdated", "statusFilterUpdated"],
            "user-customer": ["dateFilterUpdated", "tagFilterUpdated"],
            "payment": ["dateFilterUpdated", "statusFilterUpdated", "paymentMethodFilterUpdated"]
        }

        var availableFilterParams = [
            "creation_date_start",
            "creation_date_end",
            "invoice_date_start",
            "invoice_date_end",
            "status_date_start",
            "status_date_end",
            "payment_due_date_start",
            "payment_due_date_end",
            "last_invoice_date_start",
            "last_invoice_date_end",
            "partnership_last_order_date_start",
            "partnership_last_order_date_end",
            "delivery_date_start",
            "delivery_date_end",
            "deadline_date_start",
            "deadline_date_end",
            "status",
            "tags",
            "method",
            "inventory_quantity_min",
            "inventory_quantity_max"
        ];

        function updateFilterCount() {
            $scope.filterCount = 0;
            angular.forEach(availableFilterParams, function(value) {
                if (
                    $scope.filters.hasOwnProperty(value)
                    && $scope.filters[value] !== undefined
                    && $scope.filters[value] !== null
                ) {
                    $scope.filterCount += $scope.filters[value].toString().split(",").length;
                }
            });
        }

        this.openFilterModal = function() {
            ModalService.showModal({
                templateUrl: require("./modal/" + component + "-filter.modal.html"),
                controller: "listingFilterModalController",
                controllerAs: "listingFilterModalCtrl",
                inputs: {
                    $attrs: {
                        filters: $scope.filters,
                        modalTitle: this.modalTitle,
                        statusService: this.statusService,
                        tagService: this.tagService,
                        componentFiltersEmitter: componentFiltersEmitter[component],
                        availableFilterParams: availableFilterParams
                    }
                }
            }).then(function(modal) {
                modal.element.modal();
                modal.element.on("hidden.bs.modal", function(e) {
                    modal.element.remove();
                });
                modal.close.then(function(result) {
                    if (result) {
                        $scope.filters = result;
                        refreshFilters();
                    }
                    modal.element.remove();
                });
            });
        };

        this.clearAll = function() {
            $scope.filters = {clear: true}
            refreshFilters();
        };

        function refreshFilters() {
            $scope.$emit("listingFilterUpdated", $scope.filters);
            updateFilterCount();
        }

        $scope.$watchCollection(function(){
            return $state.params;
        }, function(){
            $scope.filters = $state.params;
            updateFilterCount();
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/listing-filter/listing-filter.component.js
// module id = 514
// module chunks = 0